import React from "react";

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // In production replace with a real logger (Sentry, etc.)
    if (process.env.NODE_ENV !== "production") {
      console.error("ErrorBoundary caught:", error, info);
    }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        display: "flex", flexDirection: "column", alignItems: "center",
        justifyContent: "center", minHeight: this.props.fullPage ? "100vh" : 200,
        padding: 32, textAlign: "center",
      }}>
        <span className="material-symbols-outlined" style={{ fontSize: 48, color: "#e53935", marginBottom: 12 }}>
          error_outline
        </span>
        <h3 style={{ fontSize: 18, fontWeight: 700, color: "#1a1a2e", marginBottom: 8 }}>
          Something went wrong
        </h3>
        <p style={{ color: "#6b7280", fontSize: 14, marginBottom: 20, maxWidth: 360 }}>
          {this.props.message || "An unexpected error occurred. Please try refreshing the page."}
        </p>
        <button
          onClick={this.handleReset}
          style={{
            background: "#0056d2", color: "#fff", border: "none",
            borderRadius: 8, padding: "10px 24px", fontWeight: 600,
            fontSize: 14, cursor: "pointer",
          }}
        >
          Try Again
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
